import React from "react";
import { Card, Avatar, Tag, Progress, Row, Col, Popconfirm, Button } from "antd";
import { useNavigate } from "react-router-dom";

// Credit Score / Risk Grades
const riskGrades = [
  { grade: "F", label: "Critical", range: "0-349", color: "#e977773f", textColor: "#ef4444" },
  { grade: "D", label: "Poor", range: "350-499", color: "#f974163a", textColor: "#f97316" },
  { grade: "C", label: "Average", range: "500-649", color: "#f59f0b3f", textColor: "#f59e0b" },
  { grade: "B", label: "Good", range: "650-799", color: "#22c55e3c", textColor: "#22c55e" },
  { grade: "A", label: "Excellent", range: "800-1000", color: "#13c2c233", textColor: "#13c2c2" },
];

const riskLevelStyles = {
  "Low Risk": {
    color: "#13c2c233",
    textColor: "#13c2c2",
  },
  "Medium Risk": {
    color: "#f59f0b3f",
    textColor: "#f59e0b",
  },
  "High Risk": {
    color: "#ef44443c",
    textColor: "#ef4444",
  },
};



const UserCard = ({ user, onChangeStatus }) => {
  const navigate = useNavigate();
  const riskScore = user?.risk_score ?? 0;
  const level = user?.risk_level || "Low Risk";
  const levelStyle = riskLevelStyles[level] || riskLevelStyles["Low Risk"];


  return (
    <Card
      style={{
        borderRadius: 16,
        boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
        position: "relative",
      }}
      bodyStyle={{ padding: 20, paddingTop: 30 }}
    >
      {/* 🔹 Top Right Button */}
      <Button
        size="small"
        type="primary"
        style={{ position: "absolute", top: 12, right: 12, borderRadius: 6 }}
        onClick={() => navigate("/users-camp/" + btoa(user?.id))}
      >
        Campaigns
      </Button>

      {/* 🔹 User Info */}
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <Avatar
          size={56}
          style={{
            backgroundColor: levelStyle.color,
            color: levelStyle.textColor,
            fontWeight: "bold",
            border: `2px solid ${levelStyle.color}`,
          }}
        >
          {user?.name?.slice(0, 2)?.toUpperCase()}
        </Avatar>

        <div>
          <div style={{ fontSize: 18, fontWeight: 600 }}>{user?.name}</div>
          <div style={{ color: "#8c8c8c" }}>{user?.email}</div>

          <div style={{ marginTop: 6 }}>
            <Tag>{user?.organization || "IT"}</Tag>
            <Tag>{user?.designation || "user"}</Tag>
          </div>
        </div>
      </div>

      <div style={{ margin: "16px 0", borderTop: "1px solid #f0f0f0" }} />

      {/* 🔹 Risk */}
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <span>Risk Score</span>
        <span style={{ fontWeight: 600, color: levelStyle.textColor }}>
          {riskScore}
        </span>
      </div>

      <Progress
        percent={riskScore / 10}
        showInfo={false}
        strokeColor={levelStyle.textColor}
        trailColor="#f0f0f0"
      />

      <div style={{ display: "flex", justifyContent: "space-between", marginTop: 10 }}>
        <Tag
          style={{
            backgroundColor: levelStyle.color,
            color: levelStyle.textColor,
            borderRadius: 8,
            border: "none",
          }}
        >
          {level}
        </Tag>
        <span style={{ color: "#8c8c8c" }}>
          Susceptibility: {user?.susceptibility || 0}%
        </span>
      </div>

      {/* 🔹 Actions (Smaller Cards) */}
      <Row gutter={8} style={{ marginTop: 14 }}>
        <Col span={12}>
          <Card
            size="small"
            bodyStyle={{ padding: 8 }}
            style={{
              textAlign: "center",
              border: "1px solid #13C2C2",
              borderRadius: 6,
              cursor: "pointer",
              fontSize: 12,
            }}
            onClick={() => navigate("/edit-user/" + btoa(user?.id))}
          >
            <div style={{ color: "#13C2C2" }}>Edit</div>
          </Card>
        </Col>

        <Col span={12}>
          <Card
            size="small"
            bodyStyle={{ padding: 8 }}
            style={{
              textAlign: "center",
              borderRadius: 6,
              cursor: "pointer",
              fontSize: 12,
              color: user?.status ? "#52c41a" : "#f5222d",
              border: user?.status ? "1px solid #52c41a" : "1px solid #f5222d6c",
            }}
          >
            <Popconfirm
              title="Are you sure to change status?"
              onConfirm={() => onChangeStatus(user?.id)}
            >
              <div style={{ fontWeight: 600 }}>{user?.status ? "Active" : "Inactive"}</div>
            </Popconfirm>
          </Card>
        </Col>
      </Row>
    </Card>
  );
};

export default UserCard;